import React from 'react';
import StaticPage from '../components/layout/StaticPage';

export default function HowItWorks() {
    return (
        <StaticPage title="How Host-it! Works" description="The all-in-one platform for party planning and rental business management.">
            <div className="space-y-16 not-prose">
                {/* Planner Section */}
                <section>
                    <div className="text-center mb-12">
                        <span className="bg-pink-100 text-pink-700 text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wide">For Planners & Hosts</span>
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4">Everything you need to host perfectly</h2>
                        <p className="text-gray-500 mt-2 max-w-2xl mx-auto">Whether you're planning a wedding or a backyard BBQ, we've got the tools.</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="text-center p-8 rounded-2xl bg-gray-50 hover:bg-white hover:shadow-lg transition border border-transparent hover:border-pink-100">
                            <div className="text-5xl mb-6">✨</div>
                            <h3 className="text-xl font-bold mb-3 text-gray-900">1. Dream & Design</h3>
                            <p className="text-gray-600 leading-relaxed text-sm">
                                Use our <strong>AI Party Planner</strong> to generate equipment lists from a simple description. Build a custom <strong>Wedding Website</strong>, or use our smart checklists to stay organized.
                            </p>
                        </div>
                        <div className="text-center p-8 rounded-2xl bg-gray-50 hover:bg-white hover:shadow-lg transition border border-transparent hover:border-pink-100">
                            <div className="text-5xl mb-6">🛒</div>
                            <h3 className="text-xl font-bold mb-3 text-gray-900">2. Rent Locally</h3>
                            <p className="text-gray-600 leading-relaxed text-sm">
                                Browse inventory from trusted local vendors. Check availability, request bookings, and pay securely via Stripe. Guests can even look up their orders without an account!
                            </p>
                        </div>
                        <div className="text-center p-8 rounded-2xl bg-gray-50 hover:bg-white hover:shadow-lg transition border border-transparent hover:border-pink-100">
                            <div className="text-5xl mb-6">💌</div>
                            <h3 className="text-xl font-bold mb-3 text-gray-900">3. Invite Guests</h3>
                            <p className="text-gray-600 leading-relaxed text-sm">
                                Create stunning <strong>AI-generated E-vites</strong>. Manage RSVPs, coordinate <strong>Potlucks</strong>, and even let guests add songs to your party playlist directly from the invite.
                            </p>
                        </div>
                    </div>
                </section>

                <div className="relative">
                    <div className="absolute inset-0 flex items-center" aria-hidden="true">
                        <div className="w-full border-t border-gray-200"></div>
                    </div>
                    <div className="relative flex justify-center">
                        <span className="px-4 bg-white text-lg text-gray-400 font-medium italic">Empowering Small Businesses</span>
                    </div>
                </div>

                {/* Vendor Section */}
                <section>
                    <div className="text-center mb-12">
                        <span className="bg-blue-100 text-blue-700 text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wide">For Rental Vendors</span>
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4">Run your business on autopilot</h2>
                        <p className="text-gray-500 mt-2 max-w-2xl mx-auto">A complete operating system for event rental companies.</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="text-center p-8 rounded-2xl bg-gray-50 hover:bg-white hover:shadow-lg transition border border-transparent hover:border-blue-100">
                            <div className="text-5xl mb-6">🏪</div>
                            <h3 className="text-xl font-bold mb-3 text-gray-900">1. Professional Presence</h3>
                            <p className="text-gray-600 leading-relaxed text-sm">
                                Launch a customizable <strong>Storefront</strong> in minutes. Use AI to write compelling product descriptions and polish your client messages.
                            </p>
                        </div>
                        <div className="text-center p-8 rounded-2xl bg-gray-50 hover:bg-white hover:shadow-lg transition border border-transparent hover:border-blue-100">
                            <div className="text-5xl mb-6">⚡</div>
                            <h3 className="text-xl font-bold mb-3 text-gray-900">2. Smart Logistics</h3>
                            <p className="text-gray-600 leading-relaxed text-sm">
                                Optimize delivery routes with Google Maps, manage inventory with buffer days, and draft legal <strong>Rental Contracts</strong> instantly with AI.
                            </p>
                        </div>
                        <div className="text-center p-8 rounded-2xl bg-gray-50 hover:bg-white hover:shadow-lg transition border border-transparent hover:border-blue-100">
                            <div className="text-5xl mb-6">📈</div>
                            <h3 className="text-xl font-bold mb-3 text-gray-900">3. Grow Revenue</h3>
                            <p className="text-gray-600 leading-relaxed text-sm">
                                Create discount <strong>Coupons</strong>, track taxes and expenses, and manage reviews with AI-drafted replies. Get paid fast with automated Stripe payouts.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </StaticPage>
    );
}
